import { IconName } from "@bluebottlecoffee/design-system/components";

export const getProductIconName = (
  imageType: string,
  quantity: number,
): IconName | undefined => {
  switch (imageType) {
    case "halfBag":
      return `productHalfBags${quantity}` as IconName;
    case "bag":
    case "jar":
    case "tin":
      return `product${
        imageType.charAt(0).toUpperCase() + imageType.slice(1)
      }s${quantity}` as IconName;
    default:
      return undefined;
  }
};
